let urlHead = "";
let urlarr = [
  "https://api.rakumart.it",
  "https://laravel.rakumart.es",
  "https://laveltest.rakumart.cn",
];
if (location.host.indexOf("localhost") != -1) {
  urlHead = urlarr[0];
} else if (location.host.indexOf("192.168") != -1) {
  urlHead = urlarr[0];
} else if (location.host.indexOf(".it") != -1) {
  urlHead = urlarr[0];
} else {
  urlHead = urlarr[0];
}
// if (urlHead == 'https://laveltest.rakumart.cn') {
//     alert('现在是测试接口')
// }
if (
  location.href.indexOf("rakumart.it") != -1 &&
  urlHead == "https://laveltest.rakumart.cn"
) {
  document.getElementsByTagName("body")[0].style.pointerEvents = "none";
}
export default urlHead;
